import { useState } from "react";
import { Send, Share2, Check, X } from "lucide-react";
import { toast } from "sonner";
import * as api from "@/lib/api";

const digitsOf = (p) => (p || "").replace(/[^\d]/g, "");

const shareFiles = async (files) => {
  if (navigator.canShare && navigator.canShare({ files })) {
    try { await navigator.share({ files }); return; } catch (e) { if (e?.name === "AbortError") return; }
  }
  files.forEach((f) => {
    const u = URL.createObjectURL(f);
    const a = document.createElement("a");
    a.href = u; a.download = f.name; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(u), 60000);
  });
  toast.success("Allegati scaricati: trascinali nella chat Telegram");
};

export default function ChatQueue({ broadcast, files, onClose }) {
  const queue = broadcast.recipients.filter((r) => r.status !== "no_phone");
  const skipped = broadcast.recipients.length - queue.length;
  const [done, setDone] = useState(new Set());
  const [idx, setIdx] = useState(0);
  const cur = queue[idx];

  const openChat = async (r, i) => {
    if (broadcast.text) { try { await navigator.clipboard.writeText(broadcast.text); toast.success("Testo copiato: incollalo nella chat"); } catch (e) { toast.error("Copia del testo non riuscita"); } }
    const a = document.createElement("a");
    a.href = `tg://resolve?phone=${digitsOf(r.phone)}`; a.click();
    try { await api.markBroadcastOpened(broadcast.id, r.patient_id); } catch (e) { console.error(e); }
    setDone((s) => new Set(s).add(r.patient_id));
    setIdx(Math.min(i + 1, queue.length));
  };

  return (
    <div className="space-y-3" data-testid="chat-queue">
      <div className="rounded-lg border border-[hsl(199_89%_55%)]/30 bg-[hsl(199_89%_55%)]/10 p-3 text-xs text-[hsl(199_89%_75%)]">
        Per ogni paziente: premi <b>Apri chat</b>, il testo viene copiato e si apre la sua chat su Telegram. Incolla il testo{files.length ? " e allega vocale/file con il tasto Condividi allegati" : ""}, invia, poi torna qui per il prossimo.
      </div>
      {files.length > 0 && (
        <button onClick={() => shareFiles(files)} className="inline-flex w-full items-center justify-center gap-2 rounded-lg border border-white/10 px-3 py-2 text-sm font-medium hover:bg-white/5" data-testid="chat-share-attachments">
          <Share2 className="h-4 w-4" /> Condividi allegati ({files.map((f) => f.name).join(", ")})
        </button>
      )}
      <div className="text-xs font-semibold" data-testid="chat-queue-progress">{done.size}/{queue.length} chat aperte{skipped ? ` · ${skipped} senza telefono` : ""}</div>
      {cur ? (
        <button onClick={() => openChat(cur, idx)} className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-[hsl(199_89%_55%)] px-3 py-3 text-sm font-bold text-black" data-testid="chat-queue-next">
          <Send className="h-4 w-4" /> Apri chat di {cur.name}
        </button>
      ) : (
        <div className="rounded-lg bg-primary/15 p-3 text-center text-sm font-semibold text-primary" data-testid="chat-queue-complete">Tutte le chat sono state aperte</div>
      )}
      <div className="max-h-64 space-y-1 overflow-y-auto">
        {queue.map((r, i) => (
          <button key={r.patient_id} onClick={() => openChat(r, i)} className={`flex w-full items-center justify-between rounded-lg px-2 py-1.5 text-left text-xs hover:bg-white/5 ${i === idx ? "ring-1 ring-[hsl(199_89%_55%)]/50" : ""}`} data-testid={`chat-queue-item-${r.patient_id}`}>
            <span className="truncate">{r.name}</span>
            {done.has(r.patient_id) ? <Check className="h-3.5 w-3.5 text-primary" /> : <Send className="h-3.5 w-3.5 text-muted-foreground" />}
          </button>
        ))}
      </div>
      <button onClick={onClose} className="inline-flex w-full items-center justify-center gap-1.5 rounded-lg border border-white/10 px-3 py-2 text-sm hover:bg-white/5" data-testid="chat-queue-close"><X className="h-4 w-4" /> Chiudi invio</button>
    </div>
  );
}
